import HttpService from '@/services/HttpService';
import { ValidatieErrorInterface } from '@/domain/interface/validatie/ValidatieErrorInterface';

// Validatiemeldingen hangen aan een waarschuwing, niet aan een gebouweenheid of een opdracht:
// dezelfde melding kan op beide niveaus voorkomen. Vandaar een eigen service.
export default class ValidatieService {
  constructor(public http: HttpService) {}

  saveMotivering(link: string, requestBody: unknown): Promise<ValidatieErrorInterface> {
    return this.http.put<ValidatieErrorInterface>(link, requestBody);
  }
}
